module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-13-54e4de4ff2974ed7a8de1b9a49a82df7.jpg";